import React from 'react';
import { string, oneOf, node, func } from 'prop-types';
import { ArticleSnippetV2 } from '../../Molecules/ArticleSnippetV2';
import { BillboardWrapper, PanelWrapper, ArtworkWrapper } from './BillboardV2.styles';
export const BillboardV2 = _ref => {
  let {
    artwork,
    artworkImage,
    title,
    textContent,
    btnUrl,
    btnText,
    direction,
    children,
    onClick,
    color
  } = _ref;
  return /*#__PURE__*/React.createElement(BillboardWrapper, {
    direction: direction
  }, /*#__PURE__*/React.createElement(ArtworkWrapper, {
    className: "artwork-wrapper"
  }, artworkImage && /*#__PURE__*/React.createElement("img", {
    src: artworkImage,
    className: "artwork",
    alt: title
  }) || artwork || null), /*#__PURE__*/React.createElement(PanelWrapper, null, /*#__PURE__*/React.createElement(ArticleSnippetV2, {
    title: title,
    textContent: textContent,
    btnUrl: btnUrl,
    btnText: btnText,
    onClick: onClick,
    color: color
  }, children || null)));
};
BillboardV2.propTypes = {
  title: node.isRequired,
  textContent: node,
  artwork: props => {
    return !props.artwork && !props.artworkImage && new Error('One of props "artwork" or "artworkImage" was not specified.');
  },
  artworkImage: props => {
    return !props.artwork && !props.artworkImage && new Error('One of props "artwork" or "artworkImage" was not specified.');
  },
  btnUrl: string,
  btnText: string,
  direction: oneOf(['imageRight', 'imageLeft']),
  children: node,
  onClick: func,
  color: oneOf(['blue', 'branded', 'purple', 'pink'])
};
BillboardV2.defaultProps = {
  textContent: null,
  btnUrl: '',
  btnText: '',
  direction: 'imageLeft',
  children: null,
  artwork: null,
  artworkImage: '',
  onClick: undefined,
  color: 'blue'
};